import { useMemo } from 'react';

import { usePregnanciesList, usePregnancy } from '../contexts/pregnancies';

import '../../../common/styles/catalog.css';
import './styles/donor-panel.css';

// Estado de una pérdida con su FASE: busca el dx `negative` (el que la provocó) → "Perdida DX{n}".
// Pide el detalle de la preñez (diagnostics); todas acá son lost, así que el fetch es esperado.
function AbortionEstado({ pregnancyId }) {
    const { data } = usePregnancy(pregnancyId);
    const neg = (data?.diagnostics || []).find((d) => d.result === 'negative');
    const label = neg?.number ? `Perdida DX${neg.number}` : 'Perdida';
    return <span className="cat-badge cat-badge--0">{label}</span>;
}

// Pérdidas embrionarias y abortos de una donadora: preñeces con `state='lost'`.
// Usa GET /admin/pregnancies?donor=<id> (mismo fetch que el panel de activas → React
// Query lo deduplica), filtrado a lost. Read-only, pregnancies:read. Ficha de donadora.
export default function DonorAbortionsPanel({ animalId }) {
    const { data, isLoading, error } = usePregnanciesList({ donor: animalId, limit: 200 });
    const items = useMemo(() => (data?.items || []).filter((p) => p.state === 'lost'), [data]);

    return (
        <section className="cat-detail__card">
            <div className="dpreg__head">
                <h2 className="cat-detail__section-title">Pérdidas embrionarias y abortos</h2>
                {!isLoading && !error && <span className="dpreg__count">{items.length}</span>}
            </div>

            {error ? (
                <p className="dpreg__muted">{error.status === 403 ? 'Sin permiso para ver preñeces.' : (error.message || 'No se pudieron cargar los abortos.')}</p>
            ) : isLoading ? (
                <p className="dpreg__muted">Cargando…</p>
            ) : !items.length ? (
                <p className="dpreg__muted">Sin abortos registrados.</p>
            ) : (
                <table className="cat-table cat-table--compact">
                    <thead>
                        <tr><th>Receptora</th><th>Finca</th><th>Toro</th><th>Estado</th></tr>
                    </thead>
                    <tbody>
                        {items.map((p) => (
                            <tr key={p.id} className="cat-table__row">
                                <td>{p.recipient ? `${p.recipient.number ?? '—'}${p.recipient.name ? ` · ${p.recipient.name}` : ''}` : '—'}</td>
                                <td>{p.recipient_farm?.name || <span className="cat-table__empty">—</span>}</td>
                                <td>{p.sire?.name || <span className="cat-table__empty">—</span>}</td>
                                <td><AbortionEstado pregnancyId={p.id} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </section>
    );
}
